define([], function() {
  'use strict';
  const extn = aofljsConfig.isWebPSupported ? 'webp' : 'png';
  return {
    assets: {
      icon: '/content/v1.0/Badge/{badge_id}/icon/{version}/web/{status}.' + extn
    }
  };
});
